import { Injectable, NgZone } from '@angular/core';

import { ApplicationService } from './application.service';
import { Validator } from './validator';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { IAvbobConnectData, IUserInfo, ISystem, IUserRole, IMicroUI, ApplicationMode, IAvatar } from '../interface';
import { UserService } from './user.service';

import * as moment from 'moment';
import { Subject } from 'rxjs';
import { MessageService } from './message.service';

@Injectable({ providedIn: 'root' })
export class AvbobConnectData implements IAvbobConnectData {

  Zone: NgZone;

  constructor(
    private applicationService: ApplicationService,
    private userService: UserService,
    public messageService: MessageService,
    public http: HttpClient,
    private router: Router,
    private zone: NgZone,
    public Validator: Validator) {
    this.Zone = this.zone;
    this.Route(this.router);
    window["avbobconnect"] = this;
    this.applicationService.AvbobConnect = this;
  }

  public Route(router: Router) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {

      }
      else if (event instanceof NavigationEnd) {
        this.applicationService.resizeMain();
      }
    });
    return true;
  }

  public get IsLoading(): boolean {
    return this.applicationService.isBusy || this.messageService.isBusy;
  }

  public get ShowBusy(): boolean {
    return this.applicationService.isBusy;
  }

  public set ShowBusy(value: boolean) {
    this.applicationService.isBusy = value;
  }

  public ShowError(message: string) {
    return this.applicationService.showError(message);
  }

  public ShowSuccess(message: string) {
    return this.applicationService.showSuccess(message);
  }

  public get ApplicationName(): string {
    return this.applicationService.applicationName;
  }

  public set ApplicationName(value: string) {
    this.applicationService.applicationName = value;
  }

  public Avatar(username: string): IAvatar {
    return this.applicationService.Avatar(username);
  }

  public IsValidIdNumber(value: string): boolean {

    let regex = /^[0-9]{13}$/.test(value);
    if (!regex) return false;

    var nCheck = 0, nDigit = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) == 0;
  }

  public get NavigationRoute(): string {
    return window["NavigationRoute"];
  }

  public set NavigationRoute(value: string) {
    window["NavigationRoute"] = value;
  }

  public get ApplicationMode(): ApplicationMode {
    return this.applicationService.applicationMode;
  }

  public set ApplicationMode(value: ApplicationMode) {
    console.log("Application mode may not be changed");
  }

  public get PageTitle(): string {
    return this.applicationService.pageTitle;
  }

  public set PageTitle(value: string) {
    this.applicationService.pageTitle = value;
  }

  public get UserInfo(): IUserInfo {
    return this.userService.userInfo;
  }

  public set UserInfo(value: IUserInfo) {
    this.userService.userInfo = value;
  }

  public get IsKiosk(): boolean {
    return this.applicationService.isKiosk;
  }

  public get AppSettings() {
    return this.applicationService.appSettings;
  }

  public get CurrentSystem(): ISystem {
    return this.applicationService.currentSystem;
  }

  public set CurrentSystem(value: ISystem) {
    this.applicationService.currentSystem = value;
  }

  public SendOtp(number: string, message: string, applicationName = "", functionName = ""): Promise<any> {
    return this.http.get<any>(this.applicationService.apiServiceUrl + 'Application/SendOtp?mobileNumber=' + number + "&message=" + encodeURI(message) + "&application=" + applicationName + "&function=" + functionName)
      .toPromise();
  }

  public ValidateOtp(number: string, otp: string): Promise<any> {
    if (this.applicationService.environment != "PRODUCTION" && otp == "8888") {
      let promise = new Promise((resolve, reject) => {
        resolve({ Result: true });
      });
      return promise;
    }
    else {
      return this.http.get<any>(this.applicationService.apiServiceUrl + 'Application/ValidateOtp?mobileNumber=' + number + "&otp=" + otp)
        .toPromise();
    }
  }

  public AddSystemTestingRole(userRole: IUserRole) {
    if (this.applicationService.isLocal) {
      this.applicationService.testSystem.UserRoles.push(userRole);
    }
  }

  public SendEmail(title: string, message: string, sender: string, recipient: string): Promise<any> {

    let email = {
      MessageId: '',
      ToAddress: recipient,
      FromAddress: sender,
      Subject: title,
      Body: message,
      Attachments: []
    };

    return this.http.post<any>(this.applicationService.apiServiceUrl + 'User/SendEmail', email)
      .toPromise();
  }

  LoadMicro(ui: IMicroUI, port: number = 0, isPublic: boolean = false) {

    var tag = document.getElementById(ui.Name);
    var elem = document.createElement(ui.Name);
    tag.replaceWith(elem);

    if (port > 0 && this.applicationService.isLocal) {
      var url = 'http://localhost:' + port + '/';
      this.http.get(url, { responseType: 'text' })
        .toPromise()
        .then(response => {
          var applicationScript = response.split('"').find((str) => str.indexOf('main') > -1 && str.indexOf('.js') > -1);
          if (applicationScript) {
            this.loadJS(url + applicationScript, ui);
          }
          else {
            this.applicationService.showError(`Micro UI could not be loaded. Are you running the UI at ${url}?`);
            this.router.navigate(['/']);
          }
        });
    }
    else {
      var date = moment().format("YYYYMMDD");
      this.applicationService.createApplicationLog("MicroUI", ui.Name);
      var scriptUrl = `${this.applicationService.appRepositoryUrl}micro/?application=${ui.Name}&d=` + date;
      if (isPublic) {
        var scriptUrl = `${this.applicationService.appRepositoryUrl}micropublic/?application=${ui.Name}&d=` + date;
      }
      let download = this.http.get(scriptUrl, { responseType: 'blob' });
      download.subscribe(data => this.addToDOM(data, ui));
    }
  }

  DestroyMicro(ui: IMicroUI) {
    document.body.removeChild(ui.Tag);
  }

  addToDOM(data: any, ui: IMicroUI) {
    var blob = new Blob([data], { type: 'application/javascript' });
    var url = window.URL.createObjectURL(blob);
    this.loadJS(url, ui);
  }

  loadJS(url: string, ui: IMicroUI) {

    var scriptTag = document.createElement('script');
    scriptTag.src = url;

    scriptTag.onload = function () {
      var require = eval("__webpack_require__");
      var app = require("./" + ui.Name + "/main.ts");
      app.load(ui);
    };

    document.body.appendChild(scriptTag);
    ui.Tag = scriptTag;
  };

  lookups = [];
  public LoadLookups(lookupNames: string[]) {
    lookupNames.forEach((name) => {
      if (!this.Lookup(name)) {
        this.http.get<any>(this.applicationService.apiServiceUrl + 'application/lookup?name=' + name)
          .subscribe(response => {
            this.lookups.push({ name: name, value: response });
          });
      }
    });
  }

  LookupDescription(name: string, code: any): string {
    let lookup = this.Lookup(name);
    if (lookup) {
      let lookupValue = lookup.find((entry) => entry.Code == code);
      if (lookupValue && lookupValue.Description) {
        return lookupValue.Description;
      }
    }
    return 'N/A';
  }

  Lookup(name: string) {
    let lookup = this.lookups.find((item) => item.name == name);
    if (lookup && lookup.value) {
      return lookup.value;
    }
    return null;
  }

  LogOut() {
    this.applicationService.logout();
  }

  Resize() {
    this.applicationService.resizeMain();
  }

  Log(type: string, name: string, data: any, branchCode: number = 500, branchName: string = "HEAD OFFICE") {
    if (!type) {
      type = "Function";
    }
    this.applicationService.createApplicationLog(type, name, data, branchCode, branchName);
  }

  public get IsInMaintenance(): boolean {
    return this.applicationService.isInMaintenance;
  }

  public get IdpAuthority(): string {
    return this.applicationService.idpAuthority;
  }

  public get IdpEnableKeycloakIdp(): string {
    return this.applicationService.idpEnableKeycloakIdp;
  }

  public get IdpClientId(): string {
    return this.applicationService.idpClientId;
  }

}

